import Vue from "vue";
let currentRequest = 0;

const MepaCodeService = {
  async fetchOne(id) {
    if (id == null) {
      return null;
    }
    try {
      const data = await Vue.$jsonApi.find("mepa_codes", id, {});
      return data.data[0];
    } catch (error) {
      console.log("fetchOne error: ", error);
      return { error: error };
    }
  },
  async fetchAll(searchFilterPagination) {
    try {
      const request = ++currentRequest;
      console.log(`[${request}] START MEPA_CODES `, searchFilterPagination.search);
      const res = await Vue.$jsonApi.findAll("mepa_codes", searchFilterPagination);
      if (request !== currentRequest) {
        console.log(`[${request}] MEPA_CODES DISCARDED`);
        return null;
      }
      console.log(`[${request}] END MEPA_CODES `, searchFilterPagination.search);
      return res;
    } catch (error) {
      console.log("fetchAll error: ", error);
      return { error: error };
    }
  },

  async createOrUpdate(payload) {
    try {
      if (payload.id == "" || payload.id == null) {
        return await Vue.$jsonApi.create("mepa_code", payload);
      } else {
        return await Vue.$jsonApi.update("mepa_code", payload);
      }
    } catch (error) {
      console.log("createOrUpdate error: ", error);
      return { error: error };
    }
  },

};

export { MepaCodeService };
